import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2606_23510)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M12 24c2.823 0 5.553-1.012 7.73-2.86l-8.471-8.31c-.235-.212-.283-.412-.283-.73V.035C4.871.565 0 5.78 0 11.995 0 18.561 5.447 24 12 24m12-12.006c0-1.765-.435-3.613-1.176-5.12l-9.612 5.532 7.682 7.592A11.97 11.97 0 0 0 24 11.994m-11.447-1.036 9.494-5.461C20 2.283 16.294.153 12.553 0z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2606_23510" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }